import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  return <Section data-id="element-151">
      <div className="bg-white border-2 border-brand-success rounded-3xl p-8 md:p-12 text-center max-w-3xl mx-auto shadow-card" data-id="element-152">
        <div className="text-5xl mb-6" data-id="element-153">🛡️</div>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-6 text-brand-title" data-id="element-154">
          GARANTÍA TOTAL 7 DÍAS
        </h2>
        <p className="font-body text-xl text-brand-text leading-relaxed mb-4" data-id="element-155">
          Si en los primeros 7 días no ves que este material transforma tu forma
          de enseñar, te devolvemos cada céntimo. Sin preguntas. Sin
          formularios. Sin esperas.
        </p>
        <p className="font-body text-lg text-brand-textMuted" data-id="element-156">
          +400 instructoras formadas en España. Sabemos que funciona.
        </p>
      </div>
    </Section>;
}